import ReactQuill, { ReactQuillProps } from 'react-quill'
import React, { useEffect, useState } from 'react'
import { Field, TFieldSize, TFieldTheme } from '../utility/field/Field'

export interface IBpTextEditorProps extends ReactQuillProps {
  label?: string
  fieldSize?: TFieldSize
  max?: number
}

export const BpTextEditor = (props: IBpTextEditorProps) => {
  const { label, fieldSize, ...field } = props
  const [theme, setTheme] = useState<TFieldTheme>('default')
  const [message, setMessage] = useState<string>()
  const [isFocus, setIsFocus] = useState<boolean>(false)

  useEffect(() => {
    if (isFocus && field.value) {
      if (props.max && field.value.length > props.max) {
        setTheme('error')
        setMessage(`Please keep text under ${props.max} characters`)
      } else {
        setTheme('default')
        setMessage('')
      }
    }
  }, [field.value])

  return (
    <Field fieldSize={'lg'} label={label} message={message} theme={theme}>
      <ReactQuill
        {...field}
        modules={{
          toolbar: [['bold', 'italic', 'underline', 'strike'], ['clean']],
        }}
        className={'h-[150px]'}
        formats={['bold', 'italic', 'underline', 'strike']}
        theme={'bubble'}
        onFocus={() => setIsFocus(true)}
      />
    </Field>
  )
}
